<!-- <div 
  class="trustpilot-widget"
  [class.white-bg]="bgWhite"
  [class.padd-top]="paddTop"
  data-locale="en-US" 
  data-template-id="5419b6ffb0d04a076446a9af" 
  data-businessunit-id="5eaff811e471410001a1305c" 
  data-style-height="20px" 
  data-style-width="100%" 
  data-token="4164541d-d452-48a6-ba51-90b6a52613a9"
  *ngIf="isBrowser"
>
  <a href="https://www.trustpilot.com/review/vertofx.com" target="_blank" rel="noopener">Trustpilot</a>
</div> -->

<div 
  class="trustpilot-widget" 
  [class.white-bg]="bgWhite"
  [class.padd-top]="paddTop"
  data-locale="en-GB" data-template-id="5419b732fbfb950b10de65e5" data-businessunit-id="69440e5e1d2da56aaca47a91" data-style-height="24px" data-style-width="100%" data-token="b2f17544-4ecf-45a4-ae4d-2b194f342d3f">
  <a href="https://uk.trustpilot.com/review/verto.co" target="_blank" rel="noopener">Trustpilot</a>
</div>